/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

class Dom {
    static createElement (tagName, options = {}) {
        const element = document.createElement(tagName);
        Object.keys(options).forEach(key => element.setAttribute(key, options[key]));
        return element;
    }
    static wrap (element, wrapper) {
        element.parentNode.insertBefore(wrapper, element);
        wrapper.appendChild(element);
    }
}

export {Dom};
